import { IAuthBusinessInfo } from "api/interfaces/auth-apis";
import { ISetBusinessInfo } from "../interfaces/auth.interface";

export function setBusinessInfo(data: IAuthBusinessInfo): ISetBusinessInfo {
  return {
    type: "SET_BUSINESS_INFO",
    data,
  };
}
